<admin-app-header></admin-app-header>
<div class="container-fluid">
    <div class="row header">
        <div class="col-12 p-0">
            <h2 class="mb-0">Line Charts</h2>
        </div>
    </div>

    <!-- Date Range Filter -->
    <div class="row mb-3">
        <form class="row" [formGroup]="filterForm">
            <div class="col-md-2">
                <label for="filterDateRange" class="form-label">Date Range</label>
                <select class="form-select" formControlName="filterDateRange">
                    <option *ngFor="let option of dateRangeOptions" [value]="option.value">{{ option.label }}</option>
                </select>
            </div>

            <!-- Custom Date Range Pickers -->
            <div class="col-md-2" *ngIf="isCustomDateRange">
                <label for="customStartDate" class="form-label">Start Date</label>
                <input type="date" class="form-control" formControlName="customStartDate" />
            </div>

            <div class="col-md-2" *ngIf="isCustomDateRange">
                <label for="customEndDate" class="form-label">End Date</label>
                <input type="date" class="form-control" formControlName="customEndDate" />
            </div>
        </form>
    </div>

    <div class="chart-toggles">
        <span *ngFor="let metric of dashboardMetrics" (click)="toggleChart(metric)" class="badge me-1 mb-1" [ngClass]="{ 'bg-success': isVisible(metric), 'bg-danger': !isVisible(metric) }">
            {{ getChartTitle(metric) }}
        </span>
    </div>

    <div class="row mt-3">
        <ng-container *ngFor="let chart of chartData">
            <div class="col-3" *ngIf="isVisible(chart.metric)">
                <div style="height: 200px">
                    <h5 class="px-3">{{ chart.chartTitle }}</h5>
                    <ngx-charts-line-chart
                        [results]="chart.chartData"
                        [xAxis]="true"
                        [yAxis]="true"
                        [legend]="false"
                        [showXAxisLabel]="false"
                        [showYAxisLabel]="false"
                        [xAxisLabel]="chart.xAxisLabel"
                        [yAxisLabel]="chart.yAxisLabel"
                        [autoScale]="true"
                        [timeline]="true"
                        [scheme]="chart.colourScheme"
                        [yAxisTickFormatting]="formatToK"
                    >
                    </ngx-charts-line-chart>
                </div></div
        ></ng-container>
    </div>
</div>
